export const healthRegions = [
  'Interior',
  'Fraser',
  'Vancouver Coastal',
  'Vancouver Island',
  'Northern',
];

export const siteTypesOptions = [
  'Health Authority',
  'Home Health',
  'Acute',
  'Indigenous',
  'Private',
  'Affiliate',
];

export const foundOutReasons = [
  'Friend(s) or family',
  'WorkBC',
  'Government announcement',
  'Colleague(s)',
  'Job posting through Health Authority',
  'Job posting with employer',
  'Web search',
  'Social media',
  'Other',
];

export const siteTypes = ['Long-term care', 'Assisted living', 'Both', 'Other'];
